export const normalizedSubArray = (array = [], subArrayName = "") => {
  const subArray = [];

  array.forEach((item) =>
    subArray.push(
      ...item[subArrayName].map((subItem) => ({
        ...subItem,
        label: subItem.name,
        value: subItem.id,
        [subArrayName]: item.name,
      }))
    )
  );
  return subArray.sort((item, nextItem) =>
    item.name.localeCompare(nextItem.name)
  );
};
